import axios from 'axios'
import router from '../../router'

export default {
  state: {
    user: {},
    token: null
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload
    },
    updateSession(state, students) {
      state.user.students = students
    },
    setToken(state, token) {
      state.token = token
    }
  },
  actions: {
    login ({commit, dispatch}, credentials) {
      return new Promise((resolve, reject) => {
        axios.post('/api/login', credentials).then((response) => {

          // sessionStorage.setItem('token', response.data.token)

          dispatch('setAxiosAuthHeader', response.data.token)

          commit('setUser', response.data.user)
          commit('setToken', response.data.token)
          commit('clearErrors')

          switch(response.data.user.role) {
            case 'parent':
              router.push('/dashboard')
              break
            case 'admin':
              router.push('/admin/dashboard')
              break
          }

        })
        .catch((errors) => {
          commit('setGeneralErrors', errors)
          reject()
        })
      })
    },
    setAxiosAuthHeader(context, token) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
    },
    registerUser({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        axios.post('/api/users', userInfo).then(() => {
          commit('clearErrors')
          resolve()
        })  
        .catch((errors) => {
          commit('setValidationErrors', errors)
          reject()
        })
      })
    },
    resetPassword({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/api/password/reset/', payload).then(() => {
          commit('clearErrors')
          resolve()
        })
        .catch((errors) => {
          commit('setGeneralErrors', errors)
          reject()
        })
      })
    }
  },
  getters: {
    culprit(state) {
      return state.user.id + ': ' + state.user.first_name + ' ' + state.user.last_name
    }
  }
}


